// Centralized WhatsApp helper for Goguard.
// E.164 format (no '+' or spaces) for wa.me URL.
export const WHATSAPP_NUMBER = '601114385593';

// Display format for UI (Footer, contact section, etc.)
export const WHATSAPP_DISPLAY = '+60 11-1438 5593';

export const buildWhatsAppLink = (message = '') => {
  const base = `https://wa.me/${WHATSAPP_NUMBER}`;
  if (!message) return base;
  return `${base}?text=${encodeURIComponent(message)}`;
};

/**
 * Three standardized WhatsApp intents (per Nov 2026 CRO directive):
 *   1. siteVisit     — Booking Slot Site Visit Sekarang (primary hero CTA)
 *   2. general       — Semak Pakej Sesuai (secondary + navbar)
 *   3. package(name, price) — Tanya Pakej [Guard Basic/Pro/Elite/Ultra]
 */
export const WA_MESSAGES = {
  // Primary hero + Final CTA: booking a site visit slot
  siteVisit:
    'Hi Goguard, saya nak booking slot site visit percuma.\nLokasi:\nJenis rumah:\nTarikh & masa yang sesuai:',

  // Secondary: general package check
  general:
    'Hi Goguard, saya nak semak pakej CCTV yang sesuai.\nLokasi:\nJenis rumah/premis:\nBilangan tingkat:',

  // Navbar
  navbar:
    'Hi Goguard, saya nak tanya pasal servis pemasangan CCTV.',

  // Floating widget
  floating:
    'Hi Goguard, saya ada soalan pasal servis CCTV anda.',

  // Package-specific (from pricing cards)
  package: (name, price) =>
    `Hi Goguard, saya interested dengan ${name} (${price}).\nLokasi:\nJenis rumah:\nBoleh booking slot site visit?`,

  // Legacy aliases (kept for backward compatibility with existing components)
  hero:
    'Hi Goguard, saya nak booking slot site visit percuma.\nLokasi:\nJenis rumah:\nTarikh & masa yang sesuai:',
  finalCta:
    'Hi Goguard, saya nak book konsultasi CCTV.\nLokasi:\nJenis rumah:\nTolong hubungi saya balik.',
};
